import { colorToCss } from "../../color/color"
import { IDatalayerKeyItem } from "../types"

interface Range {
    min: number
    max: number
    color: number[]
    label: string
}

export function getRangeFromValue(ranges: Range[], value: number): Range {

    value = value || 0

    let rg = ranges.find(r => (r.min <= value) && (r.max > value))

    if (!rg) {

        if (ranges[0].min > value) {
            rg = ranges[0]
        }
        else {
            const last = ranges.length - 1
            rg = ranges[last]
        }

    }

    return rg

}

export function getRangeColor(ranges: Range[], value: number) {
    const rg = getRangeFromValue(ranges, value)
    return rg ? rg.color : undefined
}

export function getRangeLabel(ranges: Range[], value: number) {
    const rg = getRangeFromValue(ranges, value)
    return rg ? rg.label : undefined
}

export function getKeyFromRanges(ranges: Range[]): IDatalayerKeyItem[] {

    return ranges.map(r => ({
        value: r.min,
        text: r.label,
        color: colorToCss(r.color)
    }))

}
